<template>
  <div class="hw-backend-run-guide-page">
    <div class="guide-scroll-area">
      <div class="hero-card">
        <h1 class="hero-title">后台运行设置引导</h1>
        <p class="hero-desc">请根据下方步骤完成设置，确保应用可正常后台运行。完成后请点击设置完成。</p>
      </div>

      <div class="guide-image-card">
        <img
          class="guide-image"
          :src="guideImage"
          alt="华为后台运行设置引导"
        />
      </div>
    </div>

    <div class="bottom-action-bar">
      <button
        class="action-btn secondary-btn"
        round
        block
        @click="handleSkip"
      >
        暂不设置
      </button>
      <button
        class="action-btn primary-btn"
        round
        block
        type="info"
        @click="handleDone"
      >
        设置完成
      </button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { handleBuryPoint } from '@/utils/tool.js';
import guideImage from '@/assets/images/hwGuide.png';

const PAGE_EVENT = 'h5-sudaseeker_hwBackendRunGuidePage';

export default {
  name: 'HwBackendRunGuidePage',
  data() {
    return {
      guideImage,
    };
  },
  created() {
    handleBuryPoint(PAGE_EVENT, 'show', {
      ...this.$route.query,
    });
  },
  methods: {
    handleSkip() {
      handleBuryPoint(PAGE_EVENT, 'skip_click', {
        ...this.$route.query,
      });
      window.AmapApp.bridge.send({
        action: 'closeCurrentWebview'
      })
    },
    handleDone() {
      handleBuryPoint(PAGE_EVENT, 'done_click', {
        ...this.$route.query,
      });
      window.AmapApp.bridge.send({
        action: 'broadcast',
        key: 'HW_PERMISSION_GUIDE',
        value: [true]
      })
      window.AmapApp.bridge.send({
        action: 'closeCurrentWebview'
      })
    },
  },
};
</script>

<style scoped>
.hw-backend-run-guide-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #eef4ff 0%, #f7f9fd 100%);
  box-sizing: border-box;
  padding: 28px 24px 184px;
}

.guide-scroll-area {
  max-width: 880px;
  margin: 0 auto;
}

.hero-card,
.guide-image-card {
  background: #ffffff;
  border-radius: 32px;
  box-shadow: 0 12px 36px rgba(30, 57, 105, 0.08);
}

.hero-card {
  padding: 36px 32px 30px;
  margin-bottom: 24px;
}

.hero-title {
  margin: 0;
  font-size: 38px;
  line-height: 1.24;
  font-weight: 700;
  color: #1b2437;
}

.hero-desc {
  margin: 18px 0 0;
  font-size: 26px;
  line-height: 1.7;
  color: #6d7a96;
}

.guide-image-card {
  overflow: hidden;
  padding: 16px;
}

.guide-image {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 24px;
}

.bottom-action-bar {
  position: fixed;
  left: 50%;
  bottom: 24px;
  transform: translateX(-50%);
  width: calc(100% - 48px);
  max-width: 880px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  padding-bottom: 8px;
}

.action-btn {
  height: 88px;
  font-size: 28px;
  font-weight: 600;
  border: none;
}

.secondary-btn {
  background: linear-gradient(90deg, #4a7dff 0%, #2f63f6 100%);
  color: #ffffff;
  border-radius: 32px;
  box-shadow: 0 10px 24px rgba(30, 57, 105, 0.08);
}

.primary-btn {
  background: linear-gradient(90deg, #4a7dff 0%, #2f63f6 100%);
  box-shadow: 0 10px 24px rgba(30, 57, 105, 0.08);
  color: #ffffff;
  border-radius: 32px;
}
</style>
